import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME } from './constants';

class EmailProvider extends BaseApi {
	async sendEmail(formData: FormData) {
		return this.uploadMultipart(`/${MODULE_API}/${NAME}/SendEmail`, formData);
	}
}
export const apiProvider = new EmailProvider(MODULE_API, NAME);
